import { API_URL } from "@constants/backend.env";
import { useAxios } from "use-axios-client";
import { API_URL_BACKEND_CAROUSEL } from "@constants/backend.env";
import { IVaultCarousel } from "@interfaces/backoffice/carousel";

const useGetCarousel = () =>
  useAxios<IVaultCarousel[]>({
    baseURL: API_URL,
    url: API_URL_BACKEND_CAROUSEL,
    params: {
      state: true,
      order: "desc",
      sort: "createdAt",
    },
  });

export default useGetCarousel;
